import { LOCATION_ORIGIN } from '@location/constants';
import { isLocationPointFromGPS } from '@commons/models/LocationPoint';
import locationToString from '@commons/models/LocationPoint/mappers/toStringWithCityAndCountry';
import trackHeaderLocationClosed from './trackHeaderLocationClosed';
import trackMapClosed from './trackMapClosed';
import trackAddressValidated from './trackAddressValidated';

const trackConfirmLocationFromMap = ({ point, trackingData }) => dispatch => {
  const data = { ...point, ...trackingData };

  dispatch(trackAddressValidated(data));
  dispatch(trackMapClosed({ trackingData, point }));

  if (data.origin === LOCATION_ORIGIN.HEADER_LOCATION) {
    if (isLocationPointFromGPS(point)) {
      dispatch(trackHeaderLocationClosed({ option: 'gps' }));
    } else {
      const address = locationToString(data, data.country);
      dispatch(
        trackHeaderLocationClosed({
          option: 'manual_address',
          locationAddress: address,
        }),
      );
    }
  }
};

export default trackConfirmLocationFromMap;
